import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResbuildmngFincanceMedic extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
            console.log("********************");
            console.log(props.resBuildmngFinanceMedic);
            console.log("*************************");

            this.state = {
                  resBuildmngFinanceMedic: this.props.resBuildmngFinanceMedic,
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  // optionElevatorKinddoor : [],


            }
      }
      componentDidMount() {

      }






      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }
      handleChangeFromUnit = (event) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.boss_to_employee_range_person_from_area = event
            this.setState({ resBuildmngFinanceMedic: temparray })
      }
      handleChangeToUnit = (event) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.boss_to_employee_range_person_to_area = event
            this.setState({ resBuildmngFinanceMedic: temparray })
      }
      handleChangeAmount = (event) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.boss_to_employee_range_person_quantity = event
            this.setState({ resBuildmngFinanceMedic: temparray })
      }
  



      modifyNewInstalmentCondition = () => {
            const { resBuildmngFinanceMedic } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_range_person")
            fd.append("boss_to_employee_range_person_id", resBuildmngFinanceMedic.boss_to_employee_range_person_id)
            fd.append("boss_to_employee_range_person_from_area", resBuildmngFinanceMedic.boss_to_employee_range_person_from_area)
            fd.append("boss_to_employee_range_person_to_area", resBuildmngFinanceMedic.boss_to_employee_range_person_to_area)
            fd.append("boss_to_employee_range_person_quantity", resBuildmngFinanceMedic.boss_to_employee_range_person_quantity)

            xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { resBuildmngFinanceMedic } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_range_person")
            fd.append("boss_to_employee_range_person_id", resBuildmngFinanceMedic.boss_to_employee_range_person_id)

            xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {  snackMode, snackstr, showSnack, visible,resBuildmngFinanceMedic } = this.state

            if (visible) {
                  return (
                      <Grid container spacing={3}>
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>

                            <Grid item item xs={2}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder="از متر مربع"
                                      handleInputt={this.handleChangeFromUnit}
                                      value={resBuildmngFinanceMedic.boss_to_employee_range_person_from_area}
                                  />
                            </Grid>
                            <Grid item item xs={2}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder=" تا متر مربع"
                                      handleInputt={this.handleChangeToUnit}
                                      value={resBuildmngFinanceMedic.boss_to_employee_range_person_to_area}
                                  />
                            </Grid>

                            <Grid item item xs={2}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder="تعداد نفر "
                                      handleInputt={this.handleChangeAmount}
                                      value={resBuildmngFinanceMedic.boss_to_employee_range_person_quantity}
                                  />
                            </Grid>

                            <Grid item xs={3}>
                                  <div style={{ width: "100%", textAlign: "left" }}>
                                        <Fab
                                            className={classes.small}
                                            style={{ background: "#44b700" }}
                                            aria-label="edit"
                                            onClick={this.modifyNewInstalmentCondition}
                                        >
                                              <EditIcon />
                                        </Fab>

                                        <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                              <DeleteIcon />
                                        </Fab>
                                  </div>
                            </Grid>
                            <Grid item xs={12}>
                                  <Divider />
                            </Grid>
                      </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResbuildmngFincanceMedic)
